module.exports = __webpack_public_path__ + "img/share_qr.cad85f74.png";